import React, { useState } from 'react';
import { Button as ButtonBS, Modal } from 'react-bootstrap';
import Button from './Button';
import { BUTTON_TYPE } from 'constants/button';
import { isMobile } from 'react-device-detect';
import { FONT_TYPES } from 'variables/font_groups';

const PreviewDocument = ({ documentLinks, buttonLabel }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const handleNext = () => {
    if (currentIndex < documentLinks.length - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const handleBack = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  return (
    <div>
      <Button
        variety={isMobile ? 1 : 4}
        fontType={FONT_TYPES.heading}
        type={BUTTON_TYPE.secondary}
        className={'category-card-button'}
        onClick={openModal}
      >
        {buttonLabel}
      </Button>
      <Modal show={modalIsOpen} onHide={closeModal} size="xl" centered>
        <Modal.Header closeButton />
        <Modal.Body
          style={{
            padding: 0,
            height: '80vh',
          }}
        >
          <iframe
            src={documentLinks[currentIndex]}
            style={{ width: '100%', height: '90%', padding: '20px 10px' }}
            title="Document Preview"
          ></iframe>
        </Modal.Body>
        <Modal.Footer style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
          {documentLinks.length > 1 && currentIndex > 0 && (
            <ButtonBS className="button button-outline" style={{ width: 120 }} onClick={handleBack}>
              Back
            </ButtonBS>
          )}
          {documentLinks.length > 1 && currentIndex < documentLinks.length - 1 && (
            <ButtonBS className="button button-primary" style={{ width: 120 }} variant="primary" onClick={handleNext}>
              Next
            </ButtonBS>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PreviewDocument;
